// Handles copying discount codes from the announcement bar when the copy icon is clicked
// Uses event delegation to support multiple slides/blocks
(function () {
  if (window.__announcementCopyBound) {
    return;
  }
  window.__announcementCopyBound = true;
  function copyTextToClipboard(text) {
    if (!text) {
      return Promise.reject(new Error('No text to copy'));
    }

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      try {
        var textArea = document.createElement('textarea');
        textArea.value = text;
        // Avoid scrolling to bottom
        textArea.style.position = 'fixed';
        textArea.style.top = '-1000px';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        var successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        if (successful) {
          resolve();
        } else {
          reject(new Error('execCommand failed'));
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function findDiscountCodeElement(startElement) {
    if (!startElement) return null;
    // Prefer searching within the current slide
    var slide = startElement.closest('.announcement-slider__slide');
    if (slide) {
      var inSlide = slide.querySelector('.announcement-discount_code');
      if (inSlide) return inSlide;
    }
    // Fallback: search within the same parent wrapper
    var parent = startElement.closest('.announcement-discount_code__parent');
    if (parent) {
      var inParent = parent.querySelector('.announcement-discount_code');
      if (inParent) return inParent;
    }
    // Last resort: global (first) match
    return document.querySelector('.announcement-discount_code');
  }

  function handleClick(event) {
    var target = event.target;
    if (!target) return;

    // Accept clicks on the icon span or any child within it
    var copyTrigger = target.id === 'announcement_copy' ? target : target.closest('.announcement-discount_code__parent');
    if (!copyTrigger) return;

    var codeEl = findDiscountCodeElement(copyTrigger);
    if (!codeEl) return;
 
    var codeText = (codeEl.textContent || '').trim();
    if (!codeText) return;

copyTrigger.querySelector('.announcement-copy').style.display = "none"; 
var next = copyTrigger.querySelector('#checkicon');

if (next) {
  next.style.display = "flex"; 
  next.classList.add('scale-animate');
  setTimeout(() => {
    copyTrigger.querySelector('.announcement-copy').style.display = "flex"; 
    next.style.display = "none";
  next.classList.remove('scale-animate');
  }, 3000);
}

    copyTextToClipboard(codeText)
      .then(function () {
        // Toast feedback
        //showToast('Copied to clipboard');
        // Optional lightweight attribute feedback
        try {
          copyTrigger.setAttribute('data-copied', 'true');
          var originalTitle = copyTrigger.getAttribute('title');
          copyTrigger.setAttribute('title', 'Copied!');
          setTimeout(function () {
            copyTrigger.removeAttribute('data-copied');
            if (originalTitle !== null) {
              copyTrigger.setAttribute('title', originalTitle);
            } else {
              copyTrigger.removeAttribute('title');
            }
          }, 1200);
        } catch (e) {
          // no-op if attributes are not allowed
        }
      })
      .catch(function () {
        // Swallow errors silently to avoid UX interruption
      });
  }

  function ensureToastContainer() {
    var containerId = 'announcement-toast-container';
    var existing = document.getElementById(containerId);
    if (existing) return existing;
    var container = document.createElement('div');
    container.id = containerId;
    container.style.position = 'fixed';
    container.style.left = '50%';
    container.style.top = '20px';
    container.style.transform = 'translateX(-50%)';
    container.style.zIndex = '9999';
    container.style.display = 'flex';
    container.style.flexDirection = 'column';
    container.style.gap = '8px';
    container.style.pointerEvents = 'none';
    document.body.appendChild(container);
    return container;
  }

  function showToast(message) {
    var container = ensureToastContainer();
    var toast = document.createElement('div');
    toast.textContent = message || 'Copied';
    toast.style.background = 'rgba(0,0,0,0.85)';
    toast.style.color = '#fff';
    toast.style.padding = '8px 12px';
    toast.style.borderRadius = '6px';
    toast.style.fontSize = '14px';
    toast.style.boxShadow = '0 4px 14px rgba(0,0,0,0.25)';
    toast.style.opacity = '0';
    toast.style.transition = 'opacity 160ms ease, transform 160ms ease';
    toast.style.transform = 'translateY(-8px)';
    toast.style.pointerEvents = 'auto';
    container.appendChild(toast);

    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });

    setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-8px)';
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 200);
    }, 1400);
  }

  // Attach once when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.addEventListener('click', handleClick, { passive: true });
    });
  } else {
    document.addEventListener('click', handleClick, { passive: true });
  }
})();


